<button
    mat-button
    class="timezone-button"
    (click)="toggleTimezonePanel()"
>
    Time Zone: (UTC {{ selectedTimezoneInfo.offset }})
</button>

<div
    *ngIf="showTimezonePanel"
    class="timezone-panel"
>
    <input
        type="search"
        name="search"
        id="Search"
        [(ngModel)]="searchText"
        (input)="filterTimezones()"
    />
    <div class="timezone-list">
        <div
            *ngFor="let zone of timezones"
            class="timezone-item"
            (click)="selectTimezone(zone.name)"
            [ngClass]="{ selected: zone.name === selectedTimezone }"
        >
            (UTC {{ zone.offset }}) {{ zone.name.split('/').pop() }}
        </div>
    </div>
</div>

<!-- <div class="containerZone">
  <div class="showZone">
    <mat-label> Time Zone:</mat-label>
    <mat-select>
      <input type="search" name="search" id="Search" [(ngModel)]="searchText" (input)="filterTimezones()">
      <mat-option *ngFor="let zone of timezones" [value]="zone" (click)="selectTimezone(zone.name)"> (UTC
        {{ zone.offset }}) {{ zone.name.split('/').pop() }}
      </mat-option>
    </mat-select>



  </div>
</div> -->
